// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5145361d","703":"bebb20e7","787":"07fa181e"}[chunkId] + ".chunk.js";
};